import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TEACHER_ROUTE } from 'app/teacher/routing-constants/teacher-routing.constant';
import { TeacherService } from 'app/teacher/services/teacher.service';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'kh-renew-class-modal',
    templateUrl: './renew-class-modal.component.html',
    styleUrls: ['./renew-class-modal.component.less'],
    standalone: false
})
export class RenewClassModalComponent {
  public constructor(
    private readonly bsModalRef: BsModalRef,
    private readonly router: Router,
    private readonly teacherService: TeacherService) { }

  public classId(): string {
    return this.teacherService.activeClassId;
  }

  public goToContact(): void {
    const route = TEACHER_ROUTE.HELP_CENTER.route(this.classId());
    this.router.navigate(route);
    this.cancel();
  }

  public cancel(): void {
    this.bsModalRef.hide();
  }
}